import { FC } from 'react';

import { Dayjs } from 'dayjs';

import { padZeros, useCountdown } from './useCountdown';

import css from './LotteryPanel.module.css';

import { fileSrc } from 'v2/utils';

interface LotteryPanelProps {
  imageId: string;
  description: string;
  promoTexts: string[];
  endDate: Dayjs | string | null;
}

export const LotteryPanel: FC<LotteryPanelProps> = ({ imageId, description, promoTexts, endDate }) => {
  const { days, hours, minutes, seconds } = useCountdown(endDate);

  const isOver = days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0;

  return (
    <div className={css.lotteryPanel}>
      {imageId ? (
        <img className={css.lotteryPicture} src={fileSrc(imageId)} alt="" />
      ) : (
        <div className={css.lotteryPicture} />
      )}

      <div className={css.lotteryFooter}>
        <p className={css.lotteryDescription}>{description}</p>
        {promoTexts.length > 0 && (
          <div className={css.lotteryPromos}>
            {promoTexts.map((text, idx) => (
              <span key={idx} className={css.lotteryPromoChip}>
                {text}
              </span>
            ))}
          </div>
        )}
      </div>

      {!isOver && (
        <span className={css.lotteryCountdown}>
          {padZeros(days)} : {padZeros(hours)} : {padZeros(minutes)} : {padZeros(seconds)}
        </span>
      )}
    </div>
  );
};
